import * as signalR from '@microsoft/signalr';
import { useDispatch } from 'react-redux';

import { update as updateProjectList, remove as removeProjectList } from '../reducers/models/project/projectList';
import { update as updateParameterList, remove as removeParameterList, updateObject as parameterUpdateObject, updateProject as parameterUpdateProject } from '../reducers/models/parameter/parameterList';
import { update as updateLabelList, remove as removeLabelList, updateObject as labelUpdateObject, updateProject as labelUpdateProject } from '../reducers/models/label/labelList';

//ЗАДАЧИ
import { update as taskUpdate, updateLabel as taskLabelUpdate, updateCheckList as taskCheckListUpdate, updateUser as taskUserUpdate, userView as taskUserView } from '../reducers/models/task/taskList';
//РЕГУЛЯРНЫЕ ЗАДАЧИ
import { update as updateTaskR, updateLabel as taskRLabelUpdate, updateCheckList as taskRCheckListUpdate, updateTimetable as taskRTimetableUpdate, updateUser as taskRUserUpdate } from '../reducers/models/taskR/taskRlist';
//РЕГУЛЯРНЫЕ ЗАДАЧИ.ТРЕКЕР
import { update as taskRTrackerUpdate, updateCheckList as taskRTrackerCheckListUpdate, loadLabelList as taskRTrackerLoadLabelList, updateUser as taskRTrackerUpdateUser, complete as taskRTrackerComplete, completeMass as taskRTrackerCompleteMass, updateLabelSetting as taskRTrackerUpdateLabelSetting, userView as taskRTrackerUserView } from '../reducers/models/taskRTracker/taskRTrackerList';
//ДОСКИ
import { load as loadBoardProjectList, loadTransfer as loadBoardProjectTransfer, loadUser as loadBoardProjectUser } from '../reducers/models/board/boardProjectList'
import { update as updateBoardTaskList, remove as removeBoardTaskList, updateLabel as boardTaskLabelUpdate, updateCheckList as boardTaskCheckListUpdate } from '../reducers/models/board/boardTaskList';
import { update as updateBoard } from '../reducers/models/board/boardList';
//МЕНЮ
//import { updateTaskR as menuUpdateRtask, updateRequest as menuUpdateRequest } from '../reducers/models/menuData';
//НАСТРОЙКИ
import { updateUser as settingUserUpdate, updateBotMax as settingUpdateBotMax } from '../reducers/models/setting';
//ПОЛЬЗОВАТЕЛИ
import { update as userUpdate, remove as userRemove, loadList as userLoad } from '../reducers/models/user/userList';
//WIDGET
import { load as loadWidget, loadTextHtml, loadParameter, loadFile } from '../reducers/models/widgetData';
//КОМПАНИИ
import { update as companyUpdate, updateExternal as companyUpdateExternal, remove as companyRemove, loadListInRequest as companyLoadListInRequest, loadListOutRequest as companyLoadListOutRequest, changed as companyChanged } from '../reducers/models/company/companyList';
//ПОДДЕРЖКА
import { messageAdd as ticketMessageAdd, add as ticketAdd, unreadLoad as ticketUnreadLoad } from '../reducers/models/ticket';
//БИЛЛИНГ
import { companySet as billingCompanySet, transactionSet as billingTransactionSet } from '../reducers/models/billing';


const hubConnection = new signalR.HubConnectionBuilder()
    .withUrl('/api_tracker/ws/tracker')
    .withAutomaticReconnect()
    .build();

export function hubConnect() {
    hubConnection
        .start(function () {
            //console.log('ws_board_connect: start')
            //Test();
        })
        .then(function () {
            //console.log('ws_board_connect: ok')
            //Test();
        })
        .catch(function (err) {
            //console.log('ws_board_connect: error', err)
            //setTimeout(() => hubConnect(), 5000);   
        });
}
export function testReceive() {
    hubConnection.on("testReceive", function (test) {
        // console.log('hub test', test)
    });
}
/**********************************START КОМПАНИИ*****************************************/
export function CompanyReceive() {
    const dispatch = useDispatch();

    hubConnection.on("companyRemoveReceive", function (data) {
        dispatch(companyRemove({ id_company: JSON.parse(data) }));
    });

    hubConnection.on("companyChangeReceive", function (data) {
        dispatch(companyChanged());
    });

    hubConnection.on("companyUpdateReceive", function (data) {
        dispatch(companyUpdate({ model: JSON.parse(data) }));
    });

    hubConnection.on("companyExternalListUpdateReceive", function (data) {
        dispatch(companyUpdateExternal({ data: JSON.parse(data) }));
    });

}
/***********************************END КОМПАНИИ******************************************/
/**********************************START НАСТРОЙКИ****************************************/
export function SettingUserUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("settingUserUpdateReceive", function (data) {
        dispatch(settingUserUpdate({ data: JSON.parse(data) }));
    });
}
export function BotMaxUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("botMaxUpdateReceive", function (data) {
        console.log('botMaxUpdateReceive', data)
        dispatch(settingUpdateBotMax({ data: JSON.parse(data) }));
    });
}
/***********************************END НАСТРОЙКИ*****************************************/
/***********************************START ПРОЕКТЫ*****************************************/
export function ProjectUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("projectUpdateReceive", function (id_project, model1, model2, model3) {
        dispatch(updateProjectList({ model: JSON.parse(model1), listObject: JSON.parse(model2), listUser: JSON.parse(model3) }));
    });
}
export function ProjectRemoveReceive() {
    const dispatch = useDispatch()
    hubConnection.on("projectRemoveReceive", function (id_project) {
        dispatch(removeProjectList({ id_project: id_project }));
    });
}
/************************************END ПРОЕКТЫ******************************************/
/**********************************START ПАРАМЕТРЫ****************************************/
export function ParameterUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("parameterUpdateReceive", function (id_parameter, model/*, listObject, listProject*/) {
        dispatch(updateParameterList({ id_parameter: id_parameter, model: JSON.parse(model)/*, listObject: JSON.parse(listObject), listProject: JSON.parse(listProject)*/ }));
    });
}
export function ParameterRemoveReceive() {
    const dispatch = useDispatch()
    hubConnection.on("parameterRemoveReceive", function (id_parameter) {
        dispatch(removeParameterList({ id_parameter: id_parameter }));
    });
}

export function ParameterObjectUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("parameterObjectUpdateReceive", function (id_parameter, data) {
        dispatch(parameterUpdateObject({ id_parameter: id_parameter, data: JSON.parse(data) }));
    });
}
export function ParameterProjectUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("parameterProjectUpdateReceive", function (id_parameter, data) {
        dispatch(parameterUpdateProject({ id_parameter: id_parameter, data: JSON.parse(data) }));
    });
}

/***********************************END ПАРАМЕТРЫ*****************************************/
/************************************START LABEL******************************************/
export function LabelUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("labelUpdateReceive", function (id_label, model/*, listObject, listProject*/) {
        dispatch(updateLabelList({ id_label: id_label, model: JSON.parse(model)/*, listObject: JSON.parse(listObject), listProject: JSON.parse(listProject) */ }));
    });
}
export function LabelRemoveReceive() {
    const dispatch = useDispatch()
    hubConnection.on("labelRemoveReceive", function (id_label) {
        dispatch(removeLabelList({ id_label: id_label }));
    });
}

export function LabelObjectUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("labelObjectUpdateReceive", function (id_label, data) {
        dispatch(labelUpdateObject({ id_label: id_label, data: JSON.parse(data) }));
    });
}
export function LabelProjectUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("labelProjectUpdateReceive", function (id_label, data) {
        dispatch(labelUpdateProject({ id_label: id_label, data: JSON.parse(data) }));
    });
}

/*************************************END LABEL*******************************************/
/************************************START WIDGET*****************************************/
export function WidgetUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("widgetUpdateReceive", function (list) {
        dispatch(loadWidget({ list: JSON.parse(list) }));
    });
}

export function WidgetHtmlUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("widgetHtmlUpdateReceive", function (data) {
        dispatch(loadTextHtml({ data: JSON.parse(data) }));
    });
}

export function WdgetFileUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("widgetFileUpdateReceive", function (data) {
        dispatch(loadFile({ data: JSON.parse(data) }));
    });
}

export function WidgetParameterUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("widgetParameterUpdateReceive", function (data) {
        dispatch(loadParameter({ data: JSON.parse(data) }));
    });
}
/*************************************END WIDGET*****************************************/
/************************************START ЗАДАЧИ*****************************************/

export function TaskUpdate() {
    const dispatch = useDispatch()

    //Обновит задачу
    hubConnection.on("taskUpdateReceive", function (model) {
        dispatch(taskUpdate({ model: JSON.parse(model) }));
    });
    //Обновит пользователей
    hubConnection.on("taskUserUpdateReceive", function (task, users) {
        dispatch(taskUserUpdate({ task: JSON.parse(task), users: JSON.parse(users) }));
    });
    //Обновит Widget метки
    hubConnection.on("taskLabelUpdateReceive", function (data, id_task) {
        dispatch(taskLabelUpdate({ data: JSON.parse(data), id_task: id_task }));
    });
    //Обновит Widget чек-лист
    hubConnection.on("taskChecklistUpdateReceive", function (data, id_task) {
        dispatch(taskCheckListUpdate({ data: JSON.parse(data), id_task: id_task }));
    });
    //Сделает задачу прочитанной
    hubConnection.on("taskUserViewReceive", function (id_task, id_user) {
        dispatch(taskUserView({ id_task: id_task, id_user: id_user }));
    });
}


/*************************************END ЗАДАЧИ******************************************/
/*******************************START РЕГУЛЯРНЫЕ ЗАДАЧИ***********************************/
//Обновит задачу (настройки)
export function TaskRUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("taskRUpdateReceive", function (data) {
        dispatch(updateTaskR({ model: JSON.parse(data) }));
    });
}
//Обновит Widget метки
export function TaskRLabelUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("taskRLabelUpdateReceive", function (data, id_task) {
        dispatch(taskRLabelUpdate({ data: JSON.parse(data), id_task: id_task }));
        //Обновляем трекер
        dispatch(taskRTrackerUpdateLabelSetting({ data: JSON.parse(data), id_task_r: id_task }));
    });
}
//Обновит пользователей
export function TaskRUserUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("taskRUserUpdateReceive", function (data, id_task) {
        dispatch(taskRUserUpdate({ data: JSON.parse(data), id_task: id_task }));
    });
}
//Обновит расписания
export function TaskRTimetableUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("taskRTimetableUpdateReceive", function (data, id_task) {
        dispatch(taskRTimetableUpdate({ data: JSON.parse(data), id_task: id_task }));
    });
}
//Обновит Widget чек-лист
export function TaskRChecklistUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("taskRChecklistUpdateReceive", function (data, id_task) {
        dispatch(taskRCheckListUpdate({ data: JSON.parse(data), id_task: id_task }));
    });
}
/********************************END РЕГУЛЯРНЫЕ ЗАДАЧИ************************************/
/****************************START РЕГУЛЯРНЫЕ ЗАДАЧИ.ТРЕКЕР*******************************/

export function TaskRTrackerUpdateReceive() {
    const dispatch = useDispatch()

    //Обновит задачи
    hubConnection.on("TaskRTrackerUpdateReceive", function (model) {
        dispatch(taskRTrackerUpdate({ model: JSON.parse(model) }));
    });
    //Завершит задачу
    hubConnection.on("taskRTrackerCompleteReceive", function (data) {
        dispatch(taskRTrackerComplete({ id: data }));
    });
    //Завершит все поставленные задачи для определенной задачи
    hubConnection.on("taskRTrackerCompleteMassReceive", function (data, menu_count) {
        dispatch(taskRTrackerCompleteMass({ ids: data }));
    });
    //Обновит Widget чек-лист
    hubConnection.on("taskRTrackerChecklistUpdateReceive", function (data, id_task) {
        dispatch(taskRTrackerCheckListUpdate({ data: JSON.parse(data), id_task: id_task }));
    });
    //Обновит метки
    hubConnection.on("taskRTrackerLabelUpdateReceive", function (data, id_task) {
        dispatch(taskRTrackerLoadLabelList({ list: JSON.parse(data), id_task: id_task }));
    });
    //Обновит пользователей
    hubConnection.on("taskRTrackerUserUpdateReceive", function (data, id_task) {
        dispatch(taskRTrackerUpdateUser({ data: JSON.parse(data), id_task: id_task }));
    });
    //Сделает задачу прочитанной
    hubConnection.on("taskRTrackerUserViewReceive", function (id_task, id_user) {
        dispatch(taskRTrackerUserView({ id_task: id_task, id_user: id_user }));
    });
}

/*****************************END РЕГУЛЯРНЫЕ ЗАДАЧИ.ТРЕКЕР********************************/
/************************************START ДОСКИ******************************************/
//Обновит Доску
export function BoardUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("boardUpdateReceive", function (model) {
        dispatch(updateBoard({ model: JSON.parse(model) }));
    });

    //Обновит связку доска-проекты
    hubConnection.on("boardProjectListUpdateReceive", function (model, id_project) {
        dispatch(loadBoardProjectList({ list: JSON.parse(model), id_project: id_project }));
    });
    //Обновит список доступных пользователей доски
    hubConnection.on("boardProjectUserUpdateReceive", function (model, id_project) {
        dispatch(loadBoardProjectUser({ list: JSON.parse(model), id_project: id_project }));
    });
    //Обновит список доступных досок для перемещения
    hubConnection.on("boardProjectTransferUpdateReceive", function (model, id_project) {
        dispatch(loadBoardProjectTransfer({ list: JSON.parse(model), id_project: id_project }));
    });


    //Обновит задачу
    hubConnection.on("boardTaskUpdateReceive", function (model) {
        dispatch(updateBoardTaskList({ model: JSON.parse(model) }));
    });
    //Удалит задачу
    hubConnection.on("boardTaskRemoveReceive", function (id_task) {
        dispatch(removeBoardTaskList({ id_task: id_task }));
    });


    //Обновит Widget метки
    hubConnection.on("boardTaskLabelUpdateReceive", function (data, id_task) {
        dispatch(boardTaskLabelUpdate({ data: JSON.parse(data), id_task: id_task }));
    });
    //Обновит Widget чек-лист
    hubConnection.on("boardTaskChecklistUpdateReceive", function (data, id_task) {
        dispatch(boardTaskCheckListUpdate({ data: JSON.parse(data), id_task: id_task }));
    });
}


/*************************************END ДОСКИ*******************************************/
/*******************************START РАБОТА С ЗАЯВКАМИ***********************************/
export function RequestOutUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("requestOutUpdateReceive", function (model) {
        dispatch(companyLoadListOutRequest({ data: JSON.parse(model) }));
    });
}
export function RequestInUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("requestInUpdateReceive", function (model) {
        dispatch(companyLoadListInRequest({ data: JSON.parse(model) }));
    });
}
/********************************END РАБОТА С ЗАЯВКАМИ************************************/
/*****************************START РАБОТА С ПОЛЬЗОВАТЕЛЯМИ*******************************/
export function UserUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("userUpdateReceive", function (model) {

        dispatch(userUpdate({ model: JSON.parse(model) }));
    });
}
export function UserRemoveReceive() {
    const dispatch = useDispatch()
    hubConnection.on("userRemoveReceive", function (id) {
        dispatch(userRemove({ id: JSON.parse(id) }));
    });
}
export function UserListUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("userListUpdateReceive", function (data) {
        dispatch(userLoad({ data: JSON.parse(data), id_status: 1 }));
    });
}

/******************************END РАБОТА С ПОЛЬЗОВАТЕЛЯМИ********************************/
/************************************START ТИКЕТЫ*****************************************/
export function TicketMessageUpdateReceive() {
    const dispatch = useDispatch()

    hubConnection.on("ticketAddReceive", function (data) {
        dispatch(ticketAdd({ model: JSON.parse(data) }));
    });
    hubConnection.on("ticketMessageUpdateReceive", function (data) {
        dispatch(ticketMessageAdd({ model: JSON.parse(data) }));
    });
    hubConnection.on("ticketUnreadUpdateReceive", function (data) {
        const data_ = data.length > 0 ? JSON.parse(data) : data;
        dispatch(ticketUnreadLoad({ data: data_ }));
    });
}
/*************************************END ТИКЕТЫ******************************************/
/************************************START BILLING****************************************/

export function BillingCompanyUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("billingCompanyUpdateReceive", function (data) {
        dispatch(billingCompanySet({ data: JSON.parse(data) }));
    });
}
export function BillingTransactionUpdateReceive() {
    const dispatch = useDispatch()
    hubConnection.on("billingTransactionUpdateReceive", function (data) {
        dispatch(billingTransactionSet({ data: JSON.parse(data) }));
    });
}

/*************************************END BILLING*****************************************/